module.exports = __webpack_public_path__ + "static/media/H2.6f3c5986.jpg";